// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.required:after {
  color: var(--mat-sys-on-surface-variant);
  content: " *";
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EAAgB,wCAAA;EAAwC,aAAA;AAGxD","sourcesContent":[".required:after{color:var(--mat-sys-on-surface-variant);content:\" *\"}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
